import * as React from 'react';

import Tab, { Tabs } from '@/components/elements/Button/TabButton';
import { getNewsTypeName } from '@/lib/news';
import { NewsType } from '@/pages/News/types';

import { TabHeading, TabLink, Wrapper } from './style';

interface NewsTypeSelectorProps {
  newsType: NewsType;
  isIndex?: boolean;
}

const NewsTypeSelector: React.FC<NewsTypeSelectorProps> = ({
  newsType,
  isIndex = false,
}) => {
  const tab = (type: NewsType) => (
    <Tab active={newsType === type}>{getNewsTypeName(type)}</Tab>
  );

  return (
    <Wrapper>
      <Tabs styles={{ gridTemplateColumns: 'repeat(3, 1fr)' }}>
        {(Object.values(NewsType) as NewsType[]).map(type =>
          isIndex && newsType === type ? (
            <TabHeading key={type}>{tab(type)}</TabHeading>
          ) : (
            <TabLink
              to={{ pathname: `/${type}` }}
              state={{ cancelScroll: true }}
              key={type}
            >
              {tab(type)}
            </TabLink>
          ),
        )}
      </Tabs>
    </Wrapper>
  );
};

export default NewsTypeSelector;
